import * as React from "react";
import { MediaQuery, SliderCarousel } from "@grandvisionhq/common";
/* empty css                        */
const ProductBlockSlider = ({ blockKeys, renderBlock }) => {
  const isPhone = MediaQuery.useIsPhone();
  return /* @__PURE__ */ React.createElement(SliderCarousel, { itemWidth: isPhone ? 186 : 246 }, blockKeys.map(
    (blockKey, index) => renderBlock({ blockKey, className: "slideable-product-block", index })
  ));
};
export {
  ProductBlockSlider
};
//# sourceMappingURL=ProductBlockSlider.js.map
